import React, {useRef,useState} from 'react';

// Partials
import HeaderStyle1 from '../../components/partials/backend/HeaderStyle/HeaderStyle1';
import SidebarStyle from '../../components/partials/backend/SidebarStyle/SidebarStyle'
import FooterStyle from '../../components/partials/backend/FooterStyle/FooterStyle'


// Router Component
import Layout1Route from '../../router/layout1-route'
import { CSSTransition } from 'react-transition-group';



const Layout1 = () => {
    const [inProp, setInProp] = useState(false);
    const nodeRef = useRef(null);
    
    return(
        <>
         <div className="wrapper">
            <HeaderStyle1 />
            <SidebarStyle />

            <div className="content-page" ref={nodeRef}>
                <Layout1Route />
            </div>
         </div>
         <FooterStyle />
        </>
    )
}


export default Layout1;